import { handleVersionMismatch } from 'actions/versionSync';
import { VersionMismatch } from 'services/BaseService';
import * as StoryletActionTypes from '../../actiontypes/storylet';
import StoryletService from 'services/StoryletService';

const service = new StoryletService();


/** ----------------------------------------------------------------------------
 * FETCH INELIGIBLE CONTACTS
 -----------------------------------------------------------------------------*/
export default function fetchIneligibleContacts(branchId: number) {
  return async (dispatch: Function) => {
    dispatch(fetchIneligibleContactsRequested());

    try {
      const { data } = await service.fetchIneligibleContacts(branchId);
      dispatch(fetchIneligibleContactsSuccess(data));
    } catch (error) {
      if (error instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(error));
      }
      dispatch(fetchIneligibleContactsFailure(error));
    }
  };
}

const fetchIneligibleContactsRequested = () => ({
  type: StoryletActionTypes.FETCH_INELIGIBLE_CONTACTS_REQUESTED,
  ineligibleContacts: null,
});

const fetchIneligibleContactsSuccess = (data: any) => ({
  type: StoryletActionTypes.FETCH_INELIGIBLE_CONTACTS_SUCCESS,
  // TODO: just use payload here; update reducers
  ineligibleContacts: data.ineligibleContacts,
  payload: {
    ineligibleContacts: data.ineligibleContacts,
  },
});

const fetchIneligibleContactsFailure = (error: any) => ({
  type: StoryletActionTypes.FETCH_INELIGIBLE_CONTACTS_FAILURE,
  error: true,
  status: error.response && error.response.status,
});